export default "__VITE_ASSET__BYSLunB___"